module.exports = __webpack_public_path__ + "img/DJ.6d6cc31d.svg";